export default function (props: any) {
    return (
        <svg width="80" height="80" viewBox="0 0 80 80" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g fill="none" fillRule="evenodd">
                <circle stroke="#928A90" strokeWidth="2" cx="40" cy="40" r="39" />
                <g transform="translate(26 23)" fill="#FFF">
                    <rect width="9.333" height="34" rx="3.111" />
                    <rect x="18.667" width="9.333" height="34" rx="3.111" />
                </g>
            </g>
        </svg>
    );
}
